import React from 'react';
import Statistics from '../../../components/Modules/Statistics';

const StatisticTab = () => (
  <div className="tab-content">
    <Statistics />
  </div>
);

export default StatisticTab;


// WEBPACK FOOTER //
// ./src/pages/MyProfile/StatisticTab/index.js